export default __webpack_public_path__ + "0ff57cf1c07a3c70017dae2e04cd359e.jpg";